<section class="error-wrapper">
  <h6 class="title">{{errorKey | translate:{ type: type} }}</h6>
  <a class="link-learn-more" href="https://support.channels.app" target="_blank"
     translate>LEARN_MORE_HERE</a>
  <img src="/assets/img/channels/integration-error.svg"/>
</section>
